(function ($, Drupal) {
  /**
   * Video Block functionality
   * swap hide thumbnail image, show video and play
   */
   Drupal.behaviors.kinaxisImageVideoSwap = {
    attach: function (context, settings) {
      $(once('kinaxisImageVideoSwap', '.paragraph--type--video-block')).each(function () {  
        $(this).find('.video-thumb.has-video').click(function (e) {
          $(this).hide();
          var $video = $(this).parent().find('.video');
          $video.show();
          var $iframe = $video.find('iframe');
          $iframe.attr('allow', 'autoplay; encrypted-media');
          $iframe[0].src = $iframe[0].src.replace("autoplay=0", "autoplay=1");
        });

        $(this).find('.video-link').click(function () {
          var $videoBlock = $(this).closest('.video-block');
          $videoBlock.find('.video-thumb.has-video').hide();
          var $video = $videoBlock.find('.video');
          $video.show();
          var $iframe = $video.find('iframe');
          $iframe.attr('allow', 'autoplay; encrypted-media');
          $iframe[0].src = $iframe[0].src.replace("autoplay=0", "autoplay=1");
        });
      });
    }
  }
})(jQuery, Drupal);